import React, { Component } from "react";
import styles from "./VisualitzacioMenuLateral.module.css";

import VisualitzacioTipus from "./VisualitzacioTipus";
import VisualitzacioParametresCerca from "./VisualitzacioParametresCerca";
import VisualitzacioLiniaTemporal from "./VisualitzacioLineaTemporal";

class VisualitzacioMenuLateral extends Component {
  render() {
    return (
      <div className={styles.Menu}>
        <div className={styles.MenuTipusWrapper}>
          <VisualitzacioTipus />
        </div>
        <div className={styles.MenuParametresCercaWrapper} role="search">
          <VisualitzacioParametresCerca />
        </div>
        <VisualitzacioLiniaTemporal />
      </div>
    );
  }
}

export default VisualitzacioMenuLateral;
